import React from 'react'
import * as Yup from 'yup'

import { KeyedTokenFields } from '../pathMapping/KeyedTokenFields'

import { TcnSourceHelp } from './TcnSourceFields'
import {
  splitToken,
  joinToken,
  isQualifiedToken,
  isWholeValuePrefix,
  METADATA_KEY_PATTERN,
  PATH_EXAMPLES,
  PREFIX_OPTION_GROUPS,
} from './tokenSources'

const FIELD = 'call_metadata_fields'

export const CALL_METADATA_SCHEMA = Yup.array().of(
  Yup.object({
    key: Yup.string()
      .required('Name is required')
      .matches(
        METADATA_KEY_PATTERN,
        'Letters, numbers and underscores only — no spaces or brackets'
      ),
    source: Yup.string().test(
      'qualified-token',
      'Choose a source and enter a path (Call Direction and Hunt Group take no path)',
      isQualifiedToken
    ),
  })
)

// TCN's "<prefix>:<path>" token, expressed as the codec the shared rows speak.
const tcnTokenCodec = {
  split: splitToken,
  join: joinToken,
  isQualified: isQualifiedToken,
}

/**
 * Call Metadata: named values pulled from the TCN payloads and sent to Remote Desktop
 * as `call_metadata`, which lands on the call record and can drive dynamic
 * checklists.
 *
 * Stores the backend shape directly, `[{ key, source }]`, where `source` is the same
 * "<source>:<path>" token the campaign-name field uses. Injected via the schema
 * `raw`/`as` hatch, so it reads and writes Formik through context.
 */
export const TcnCallMetadataFields = () => (
  <KeyedTokenFields
    field={FIELD}
    label="Call Metadata"
    codec={tcnTokenCodec}
    sources={PREFIX_OPTION_GROUPS}
    examples={PATH_EXAMPLES}
    isWholeValue={isWholeValuePrefix}
    sourceSpan={4}
    pathSpan={5}
    testIdPrefix="tcn-metadata"
    containerTestId="tcn-call-metadata"
    keyPlaceholder="account_number"
    columnLabels={['Source', 'Path']}
    addLabel="Add field"
    removeLabel="Remove call metadata field"
    help={<TcnSourceHelp />}
    caption="Each name is sent on every call, empty when its source has no value, so playbook rules always see the field. Names allow letters, numbers and underscores only."
  />
)
